/**
 * The answer key of a bridges puzzle is the list of bridges. Kept apart from the drawing
 * component so the eagerly loaded module file never pulls the author's form into the player
 * bundle.
 */
import { canonical, legalBridges } from "./graph";
import { gridOf } from "./progress";
import type { Bridge, BridgesDefinition, BridgesSolution } from "./types";

/** What the core hands the form when nothing is queued. */
export function emptySolution(_definition: BridgesDefinition): BridgesSolution {
  return { bridges: [] };
}

/** Nothing queued: not a `{bridges: [...]}` object, or an empty list. */
export function isAbsent(value: unknown): boolean {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return true;
  const list = (value as { bridges?: unknown }).bridges;
  return !Array.isArray(list) || list.length === 0;
}

/** Reads whatever is stored, however wrong, as legal bridges of the definition's grid. */
export function keyOf(value: unknown, definition: BridgesDefinition): Bridge[] {
  const list =
    typeof value === "object" && value !== null ? (value as { bridges?: unknown }).bridges : null;
  return canonical(legalBridges(gridOf(definition), list));
}
